import { Phone, MessageCircle } from "lucide-react";
import { useEffect, useState } from "react";

const PHONE = "tel:+41766388655";
const WHATSAPP = "https://wa.me/41766388655?text=Bonjour%2C%20je%20souhaite%20un%20devis.";

const MobileStickyBar = () => {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const visibleSet = new Set<Element>();

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            visibleSet.add(entry.target);
          } else {
            visibleSet.delete(entry.target);
          }
        });
        setHidden(visibleSet.size > 0);
      },
      { threshold: 0.1 }
    );

    const targets = document.querySelectorAll("[data-cta-zone]");
    targets.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 md:hidden glass-card border-t border-border/50 p-3 transition-all duration-300 ${
        hidden ? "translate-y-full opacity-0 pointer-events-none" : "translate-y-0 opacity-100"
      }`}
    >
      <div className="flex gap-3">
        <a
          href={PHONE}
          className="flex-1 flex items-center justify-center gap-2 bg-primary text-primary-foreground font-semibold text-sm py-3.5 rounded-xl glow-sm active:scale-95 transition-transform"
        >
          <Phone className="w-4 h-4" />
          Appeler
        </a>
        <a
          href={WHATSAPP}
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 flex items-center justify-center gap-2 border border-primary/30 text-primary font-semibold text-sm py-3.5 rounded-xl hover:bg-primary/10 active:scale-95 transition-all"
        >
          <MessageCircle className="w-4 h-4" />
          WhatsApp
        </a>
      </div>
    </div>
  );
};

export default MobileStickyBar;
